import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { UserResponse } from './responses/user.response';
import { UserRequest } from './requests/user.request';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';

interface PaginatedUsers {
    data: { records: UserResponse[]; totalItens: number };
}

export class UserService extends BaseService {
    protected get resourceName(): string {
        return 'crm/users';
    }

    public async paginated(
        currentPage: number,
        recordsPerPage: number,
        search?: string
    ): Promise<AxiosResponse<PaginatedUsers>> {
        const query = new URLSearchParams({
            currentPage: String(currentPage),
            recordsPerPage: String(recordsPerPage),
        });

        if (search) query.set('search', search);

        return await this.get(`paginated?${query.toString()}`);
    }

    /// Assinatura que o AbstractHook chama; a API não tem getById nem deleteById (desligar é o Active).
    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<UserResponse>>> {
        return await this.get<PagedResponse<UserResponse>>('paginated' + (filter ?? ''), params);
    }

    public async create(body: UserRequest): Promise<AxiosResponse<{ data: UserResponse }>> {
        return await this.post(body);
    }

    public async update(id: string, body: UserRequest): Promise<AxiosResponse<{ data: UserResponse }>> {
        return await this.put(id, body);
    }
}
